<template>
  <section :class="!reportMode ? 'mt-3' : ''">
    <b-alert variant="warning" :show="showWarning">
      Selezionare almeno un canale per i consumi e un solo parametro di riferimento
    </b-alert>
    <div :class="!reportMode ? 'my-5' : ''">
      <div>
        <div :style="{ height: checkChartHeight, width: 'calc(100% - 20px)' }" :id="chartId"></div>
      </div>
    </div>
  </section>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import NeedUpdateMixin from "../../NeedUpdateMixin";
import { debounce } from "lodash";
import { makeid } from "../../helpers";
import { startRender, finishRender } from "../../../../helpers/printReady";
import ChartTable from "../../Table";

export default {
  name: "ScatterChart",
  mixins: [NeedUpdateMixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "line",
    },
    reportMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    reportpopupMode: {
      required: false,
      default: false,
    },
  },
  components: { ChartTable },
  data() {
    return {
      colors: this.$store.state.colors,
      data: null,
      showWarning: false,
      chart: undefined,
      chartId: makeid(),
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    async reload() {
      this.showWarning = !(this.filter.channels.length > 0 && this.filter.parameters.length == 1);

      if (!this.showWarning) {
        this.$store.commit("loading");

        this.$store
          .dispatch("charts/get", this.filter)
          .then((data) => {
            if (data.values.length == 0) {
              return;
            }

            this.unload();

            data.values = data.values.map((v) => {
              return [v[2], v[1]];
            });

            data.sources = data.sources.map((v) => {
              return [v[1], v[0]];
            });

            data.columns = [data.columns[1], data.columns[2]];

            data.values = data.values.map((v) => {
              return {
                ax: v[0] ? v[0] : 0,
                ay: v[1] ? v[1] : 0,
              };
            });

            this.makeChart(data);
          })
          .finally(() => {
            this.$store.commit("stopLoading");
          });
      }
    },

    makeChart(data) {
      let chart = am4core.create(this.chartId, am4charts.XYChart);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let renderSettled = false;
      const settleRender = () => {
        if (renderSettled) return;
        renderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settleRender);
      setTimeout(settleRender, 8000);

      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      chart.data = data.values;

      if (this.reportMode) {
        chart.fontSize = 11;
      }

      var valueAxisX = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxisX.title.text = data.columns[0] + " [[" + data.mus[0] + "]]"; // data.columns[0];
      valueAxisX.renderer.minGridDistance = 40;
      valueAxisX.renderer.labels.template.rotation = -90;
      valueAxisX.renderer.labels.template.dx = -20;

      // Create value axis
      var valueAxisY = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxisY.title.text = data.columns[1] + " [[" + data.mus[1] + "]]"; //data.columns[1];

      this.createSeries(data, chart);
      this.chart = chart;
    },

    createSeries(data, chart) {
      var lineSeries = chart.series.push(new am4charts.LineSeries());
      lineSeries.dataFields.valueY = "ay";
      lineSeries.dataFields.valueX = "ax";
      lineSeries.strokeOpacity = 0;

      lineSeries.strokeOpacity = 0;
      var circleBullet = lineSeries.bullets.push(new am4charts.CircleBullet());
      circleBullet.circle.radius = 2;
    },

    unload() {
      try {
        // this.chart.dispose();
        this.chart = undefined;
      } catch (error) {
        console.log(error);
      }
    },

    checkChartForReports() {
      if (this.reportMode && this.filter.actionButtons) {
        this[this.filter.actionButtons]();
      }
      if (this.reportpopupMode == "table") {
        this.tableButtonClick();
      }
    },
  },
  computed: {
    formattedCharts() {
      return this.charts;
    },

    checkChartHeight() {
      if (this.reportMode) {
        return "308px";
      } else if (this.filter.split) {
        return "350px";
      } else {
        return "500px";
      }
    },
  },
  watch: {
    filter() {
      debounce(this.reload, 10)();
    },
  },
  beforeDestroy() {
    this.unload();
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Am/Scatter.vue